import React, { useState } from "react";
import ContentSelectPaymentAmount from "../../../ui-components/content-select-payment-amount/content-select-payment-amount.tsx";
import RaindropButton, {
  ButtonStyle,
} from "../../../ui-components/raindrop-button/raindrop-button.tsx";
import { fetchGraphQL } from "../../../services/api-raindrop.js";
import { useNavigate } from "react-router-dom";
import { Size } from "../../../logic/enums.ts";

const RaindropUpdateAmount = () => {
  const navigate = useNavigate();

  const [newSubunits, setNewSubunits] = useState(null);

  const [isSubmitting, setIsSubmitting] = useState(false);

  const onBack = () => {
    setNewSubunits(null);
    navigate("/raindrop/settings/contributions");
  };

  const onConfirm = () => {
    setIsSubmitting(true);

    fetchGraphQL(`
      mutation {
        updateAccountPlan(
          subunits: ${newSubunits}
        ) {
          id
        }
      }
    `)
      .then((data) => {
        console.log(data);
        navigate("/raindrop/settings/contributions");
      })
      .finally(() => {
        setIsSubmitting(false);
      });
  };

  return (
    <div className="flex flex-col items-center w-full gap-4 h-full px-4">
      <div className="flex flex-col overflow-y-scroll">
        <div className="flex flex-col gap-2 pt-10">
          <div className="text-2xl font-bold ">Update contribution amount</div>
          <div className="flex flex-col gap-2 text-color-dark-text-secondary pb-4">
            <div className="text-sm">
              This is your one and only monthly payment. You'll choose how to
              distribute it soon
            </div>
          </div>
        </div>

        <ContentSelectPaymentAmount
          newKindnessAmount={newSubunits}
          setNewKindnessAmount={setNewSubunits}
          doIncludeZero={true}
        />
      </div>

      <div
        className={
          "flex flex-row gap-2 h-fit w-full items-center justify-center "
        }
      >
        <RaindropButton
          icon={"fa-chevron-left"}
          title={"Back"}
          onClick={onBack}
          style={ButtonStyle.Secondary}
          size={Size.Large}
          isFluid={true}
        />
        <RaindropButton
          // icon={"fa-check"}
          title={"Confirm"}
          onClick={onConfirm}
          isDisabled={newSubunits === null}
          style={ButtonStyle.Primary}
          size={Size.Large}
          isFluid={true}
          isLoading={isSubmitting}
        />
      </div>
    </div>
  );
};

export default RaindropUpdateAmount;
